import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom'

// This block attaches a global error handler for development and staging environments.
// It helps catch unhandled errors and displays them in an alert for quick debugging.
// This code is excluded from the production build.
const isDevOrStaging = import.meta.env.DEV || window.location.hostname === 'dev.winefacts.org';

if (isDevOrStaging) {
  console.log("Development/Staging error handler attached.");
  window.onerror = function(message, source, lineno, colno, error) {
    console.error("Caught an unhandled error:", { message, source, lineno, colno, error });
    alert(
      "Error: " + message +
      "\nFile: " + source +
      "\nLine: " + lineno +
      "\nColumn: " + colno
    );
  };
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
      <App />
  </StrictMode>,
)
